import { z } from "zod";

/**
 * What deleting a campaign did (PREC-4258): the answer of `DELETE list/:id/campaign/:uuid`, read by
 * the builder's delete confirmation and by MCP. The counts describe this call only; a retried delete
 * of a campaign that is already gone answers what was still left to release, usually nothing.
 */
export const campaignDeletionResultSchema = z.object({
	campaignUuid: z.string(),
	/** Leads in the sequence that no message had reached: back in New. */
	leadsReturnedToNew: z.coerce.number(),
	/** Leads in the sequence that a message had reached: Ended ("Campaign deleted"). */
	leadsEnded: z.coerce.number(),
	/** Leads that had finished (replied, ended, …): keep their status, lose the campaign link. */
	leadsUnlinked: z.coerce.number(),
	/** The campaign's steps that had not run yet, cancelled. */
	schedulesCancelled: z.coerce.number(),
});

export type CampaignDeletionResult = z.infer<typeof campaignDeletionResultSchema>;
